const ProgramHero = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const hero = document.querySelector('.program-hero');
        const linksWrap = document.querySelector('.program-hero__wrap--links');
        const wrapContainer = document.querySelector('.program-hero__links-wrap');

        if (!hero || !linksWrap || !wrapContainer) return;

        const spacer = document.createElement('div');
        spacer.style.height = linksWrap.offsetHeight + 'px';
        spacer.style.display = 'none';
        wrapContainer.insertBefore(spacer, linksWrap);

        function handleScroll() {
            const heroBottom = hero.offsetTop + hero.offsetHeight;
            const scrollY = window.scrollY;

            if (scrollY > heroBottom) {
                linksWrap.classList.add('is-sticky');
                spacer.style.display = 'block';
            } else {
                linksWrap.classList.remove('is-sticky');
                spacer.style.display = 'none';
            }
        }

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', () => {
            spacer.style.height = linksWrap.offsetHeight + 'px';
        });
    });
};

export default ProgramHero;
